export const dashboardTabs = [
    { title: "Dashboard"},
    { title: "Media"},
    { title: "Users"}
]